<div>
  @if (showErrorMessage) {
    <app-alert [message]="showErrorMessage" [msgtype]="'error'" [messageHeading]="'Error'"></app-alert>
  }
</div>
<app-spinner name="employee-role-add"></app-spinner>

@if (!isRequestSuccess) {
  <div>
    <div [hidden]="!!showAdvancedSearch">
      <app-multi-org-filter-ta pageType="add-employee-role" [showRequired]="true" [showSelectRoles]="true" [isRoleAdmin]="true" (onRoleGroupChange)="onRoleGroupChange($event)"></app-multi-org-filter-ta>
      <div class="mtb-20">
        <h3>
          Add Employee Role
        </h3>
      </div>
      <div class="mtb-20 gap-20 flex" *ngIf="isDewOrg && hasProfileAdmin">
        <div class="lrg flex align-center">
          <input type="checkbox" id="dewStaff" name="dewStaff" [(ngModel)]="isDewStaff" (change)="onDewStaffChange($event)">
          <label class="ml-10" for="dewStaff">DEW Staff Members</label>
        </div>
      </div>
      <div class="fade">
        <div class="inline-text-field-container even-cols flex-row gap-20 mb-20 mobile-margin">
          <ng-select class="custom" placeholder="*Search Employee" [(ngModel)]="selectedEmployee"  name="selectedEmployee" [ngClass]="{'disabled':  !roleRequestService.isRoleAndOrgSelected()}"
            [items]="employees$ | async" [typeahead]="search$" [loading]="loading" [clearable]="true" [hideSelected]="true" placeholder="*Search Employee">
            <ng-template ng-label-tmp let-item="item" let-index="index">
              <span class="ng-value-label">{{item?.firstName + " "+ item?.lastName + (item?.emailAddress ? (" - " + item?.emailAddress) : '')}}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-index="index">
              <span class="ng-value-label">{{item?.firstName + " "+ item?.lastName + (item?.emailAddress ? (" - " + item?.emailAddress) : '') }}</span>
            </ng-template>
          </ng-select>
          <div class="mobile pl-20 " [ngClass]="selectedRoleGroup?.roleAssignGroupKey != '4'?'border-left border-gray-600':''">
            <div class="align-text">
              <a (click)="showAdvancedSearchFn()">
                Advanced Search
              </a>
            </div>
          </div>
        </div>
      </div>
      <app-role-information (onCartChange)="onCartChange($event)" [addEmployeeRole]="true"></app-role-information>
      <!--End this is the cart section -->
      <div class="container flex mobile border-top border-gray-600 mt-20 pt-10">
        <span class="basis-50">
          <span class="flex justify-start">
            <button [routerLink]="['..']"
              class="secondary border-red rounded-4 hover-red hover-font-white flex-row-reverse mobile">
              <div class="btn-txt font-red bold">Back</div>
            </button>
          </span>
        </span>
        <span class="basis-50">
          <span class="flex justify-end">
            <button class="rounded-4 hover-blue-800 black mobile"
              [class.disabled]="!rolesOnCart?.length || !selectedEmployee" (click)="submitRoleRequest()">
              <div class="btn-txt font-white bold">Submit Role Request</div>
            </button>
          </span>
        </span>
      </div>
    </div>
    @if (showAdvancedSearch) {
      <div>
        <app-role-request-advanced-search (onBack)="showAdvancedSearchFn()" (emplSelected)="emplSelected($event)"></app-role-request-advanced-search>
      </div>
    }
  </div>
}

@if (isRequestSuccess) {
  <app-role-request-success message="Your role request actions were processed."></app-role-request-success>
}
